import { Skeleton, Stack } from '@mui/material';
import { useIsMobile } from '@/data/hooks/useIsMobile';

export const MainCardViewSkeleton = () => {
	const isMobile = useIsMobile();
	return (
		<>
			<Stack width={isMobile ? '100%' : '75%'} direction="column" spacing={0} paddingTop={'18px'}>
				<Skeleton variant="text" width={250} height={43} />
				<Skeleton variant="text" width={isMobile ? '100%' : '75%'} height={43} />
				<Stack width={'100%'} direction={isMobile ? 'column' : 'row'}>
					<Stack width={'100%'} direction={'column'} sx={{ marginRight: '15px' }}>
						<Skeleton
							sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
							variant="rectangular"
							width={isMobile ? '80%' : '100%'}
							height={240}
						/>
						<Skeleton sx={{ marginRight: '15px' }} variant="text" width={'100%'} height={43} />
					</Stack>
					<Stack width={'100%'} direction={'column'}>
						<Skeleton
							sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
							variant="rectangular"
							width={isMobile ? '80%' : '80%'}
							height={75}
						/>
						<Skeleton
							sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
							variant="rectangular"
							width={isMobile ? '100%' : '80%'}
							height={210}
						/>
						<Skeleton
							sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
							variant="rectangular"
							width={isMobile ? '100%' : '80%'}
							height={80}
						/>
					</Stack>
				</Stack>
			</Stack>
			<Skeleton variant="text" width={'100%'} height={2} sx={{ marginTop: '18px' }} />
			<Skeleton variant="text" width={250} height={43} />
			<Skeleton
				sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
				variant="rectangular"
				width={'100%'}
				height={75}
			/>
			<Skeleton
				sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
				variant="rectangular"
				width={'100%'}
				height={75}
			/>
			<Skeleton
				sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
				variant="rectangular"
				width={'100%'}
				height={75}
			/>
			<Skeleton
				sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
				variant="rectangular"
				width={'100%'}
				height={75}
			/>
			<Skeleton
				sx={{ marginRight: '15px', marginBottom: '10px', borderRadius: '4px' }}
				variant="rectangular"
				width={'100%'}
				height={75}
			/>
		</>
	);
};
